import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MessageService } from '../../services/message.service';
import { ClientService } from '../../services/client.service';
import { ClientStyleService } from '../../services/client-style.service';

@Component({
	selector: 'app-base',
	template: ``,
	styles: [
	]
})

export class BaseComponent implements OnInit {

	private clientKey: string;
	public clientStyle: string = '/assets/client-styles/444.css';
	constructor(
		public router: Router, 
		public activatedRoute: ActivatedRoute, 
		public messageService: MessageService, 
		public clientService: ClientService,
		public clientStyleService: ClientStyleService) { }

	ngOnInit(): void {
		this.clientKey = this.activatedRoute.snapshot.paramMap.get("clientKey");
		if(this.clientKey == null) {
			this.clientKey = this.activatedRoute.snapshot.queryParamMap.get("clientKey");
		}
		if(this.clientKey === undefined || this.clientKey == null) {
			this.clientKey = this.clientService.getClientGuid();
		}
		if(this.clientKey != null) {
			this.clientStyleService.loadClientBranding(this.clientKey);
		}else{
			this.router.navigate(['/search']);
		}
	}
}
